if (!customElements.get("product-template-custom")) {
    class ProductTemplateCustom extends HTMLElement {
        constructor() {
            super();
        }
        connectedCallback() {
            const btnWholesale = document.getElementById("btn-wholesale");
            const btnRetail = document.getElementById("btn-retail");
            const subscriptionWidgets = document.querySelector(
                ".Avada-SubscriptionWidget-Block"
            );
            const inputQuantity = document.querySelectorAll(
                '.input-quantity[name="quantity"]'
            );
            const buyButton = document.getElementById("buy-button");
            const redirectButton = document.getElementById("redirect-button");
            const tableWholesale = document.getElementById("table-whole-sale");
            const quantityProduct = document.getElementById("quantity-product");
            if (btnRetail) {
                btnRetail.style.backgroundColor = "#849947";
                btnRetail.style.color = "#fff";
                btnRetail.classList.add("btn-wholesale-retail--active");
            }
            this.btnWholesaleClick(
                btnWholesale,
                btnRetail,
                tableWholesale,
                subscriptionWidgets,
                inputQuantity,
                buyButton,
                redirectButton,
                quantityProduct
            );
            this.btnRetailClick(
                btnRetail,
                btnWholesale,
                tableWholesale,
                subscriptionWidgets,
                inputQuantity,
                buyButton,
                redirectButton,
                quantityProduct
            );
        }

        btnWholesaleClick(
            btnWholesale,
            btnRetail,
            tableWholesale,
            subscriptionWidgets,
            inputQuantity,
            buyButton,
            redirectButton,
            quantityProduct
        ) {
            if (btnWholesale) {
                btnWholesale.addEventListener("click", () => {
                    const inputQuantity = document.querySelectorAll(
                        '.input-quantity[name="quantity"]'
                    );
                    btnRetail.removeAttribute("style");
                    btnWholesale.style.backgroundColor = "#849947";
                    btnWholesale.style.color = "#fff";

                    btnRetail.classList.remove("btn-wholesale-retail--active");
                    btnWholesale.classList.add("btn-wholesale-retail--active");
                    if (tableWholesale) {
                        tableWholesale.style.display = "block";
                    }
                    if (subscriptionWidgets) {
                        subscriptionWidgets.style.display = "none";
                    }
                    if (buyButton) {
                        buyButton.style.display = "none";
                    }
                    if (redirectButton) {
                        redirectButton.style.display = "block";
                    }
                    if (quantityProduct) {
                        quantityProduct.style.display = "none";
                    }
                });
            }
        }
        btnRetailClick(
            btnRetail,
            btnWholesale,
            tableWholesale,
            subscriptionWidgets,
            inputQuantity,
            buyButton,
            redirectButton,
            quantityProduct
        ) {
            if (btnRetail) {
                btnRetail.addEventListener("click", () => {
                    btnWholesale.removeAttribute("style");
                    btnRetail.style.backgroundColor = "#849947";
                    btnRetail.style.color = "#fff";
                    btnWholesale.classList.remove(
                        "btn-wholesale-retail--active"
                    );
                    btnRetail.classList.add("btn-wholesale-retail--active");
                    if (tableWholesale) {
                        tableWholesale.style.display = "none";
                    }
                    if (subscriptionWidgets) {
                        subscriptionWidgets.style.display = "block";
                    }
                    this.retailShowQuantity(inputQuantity);
                    if (buyButton) {
                        buyButton.style.display = "flex";
                    }
                    if (redirectButton) {
                        redirectButton.style.display = "none";
                    }
                    if (quantityProduct) {
                        quantityProduct.style.display = "block";
                    }
                });
            }
        }
        retailShowQuantity(quantity) {
            if (quantity[0]) {
                quantity[0]._x_model.set(1);
            }
        }
        tableB2BAjustQuantity(table, quantity) {
            table.forEach((tr) => {
                tr.addEventListener("click", () => {
                    tr.classList.add("qty-row-active");
                    quantity[0]._x_model.set(tr.getAttribute("data-min"));
                });
            });
        }
        disconnectedCallback() {}
    }

    customElements.define("product-template-custom", ProductTemplateCustom);
}
